<template>
  <div>
    <b-container fluid class="mt-0 pb-5 deposit-section">
      <b-row>
        <b-col xl="10" class="ml-auto mr-auto">
          <div class="p-0 pb-5">
            <h3 class="pl-3 pt-3">{{ $t('Deposit') }}</h3>
            <div class="pl-3 fz-16 fw-400">{{ $t('Deposit effortlessly to your preferred card today') }}</div>
            <hr>

            <div class="p-0">

              <b-row class="display-table pt-5 pb-5">
                <b-col sm="12" md="6">
                  <div class="bg-white pb-0 px-3 pt-0 h-100 mb-3">
                      <div class="block-shadow-item ml-1 mr-1 mb-4 px-4 py-3">
                        <h4 class="pt-0 mb-3">{{ $t('Deposit Information') }}</h4>
                        <div class="d-flex">
                          <div class="form-group mb-3 w-100 pr-1">
                            <div class="d-flex align-items-center mb-2">
                              <label class="mb-0">{{ $t('Card Number') }}<span class="text-danger">*</span></label>
                            </div>
                            <input v-model="card_number" class="form-control" :placeholder="$t('Card Number')" @keyup="checkCardNumber"/>
                            <div v-if="error.card_number" class="invalid-feedback d-block mb-3">
                              {{$t(error.card_number)}}
                            </div>
                          </div>
                        </div>
                        

                        <div class="form-group mb-3">
                          <div class="d-flex align-items-center mb-2">
                            <label class="mb-0">{{ $t('Full name as per Identity Card') }}<span class="text-danger">*</span></label>
                          </div>
                          <input v-model="fullname" class="form-control" :placeholder="$t('Full name as per Identity Card')"/>
                          <div v-if="error.fullname" class="invalid-feedback d-block mb-3">
                            {{$t(error.fullname)}}
                          </div>
                        </div> 

                        <div class="d-flex" v-if="card_id">
                          <div class="form-group mb-3 w-100 mr-2 select2-item">
                            <div class="d-flex align-items-center mb-2">
                              <label class="mb-0">{{ $t('Method') }}<span class="text-danger">*</span></label>
                            </div>
                            <Select2 v-model="method" :options="method_option" @select="onSelectMethod($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Select Method"), minimumResultsForSearch:-1}' class="form-control"/>
                            <div v-if="error.method" class="invalid-feedback d-block mb-3">
                              {{$t(error.method)}}
                            </div>
                          </div> 

                          <div class="form-group mb-3 w-100 ml-2 select2-item">
                            <div class="d-flex align-items-center mb-2">
                              <label class="mb-0">{{ $t('Network') }}<span class="text-danger">*</span></label>
                            </div>
                            <Select2 v-model="network" :options="network_option" @select="onSelectNetwork($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Select Network"), minimumResultsForSearch:-1}' class="form-control"/>
                            <div v-if="error.network" class="invalid-feedback d-block mb-3">
                              {{$t(error.network)}}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="block-shadow-item ml-1 mr-1 mb-4 px-4 py-3">
                        <h4 class="pt-0 mb-4">{{ $t('Deposit Summary') }}</h4>
                        <div class="form-group mb-3 d-flex fz-20">
                          <label class="mb-0 w-100 fz-20">{{ $t('Deposit Amount ({currency})',{currency:wallet_currency}) }}<span class="text-danger">*</span></label>
                          <div class="relative">
                            <MaskAmount @set-price="changePrice($event)" :bus="deposit"></MaskAmount>
                            <div v-if="error.amount" class="invalid-feedback d-block mb-3 fz-12">
                              {{$t(error.amount,{amount:getMinimum(),currency:wallet_currency})}}
                            </div>
                          </div>
                        </div>

                        <div class="form-group mb-3 d-flex">
                          <label class="w-100 fz-20 text-nowrap">{{ $t('Deposit Fee {percentage} ({currency})',{percentage:fee,currency:wallet_currency}) }}</label>
                          <!-- <input :value="getResult(amount*fee/100)" class="form-control text-right" disabled/> -->
                          <div class="text-right w-100 pr-2 fz-20 fw-600">{{ getResult(amount*fee/100) }}</div>
                        </div>

                        <hr class="my-2"/>
                        <div class="form-group mb-0 d-flex fz-26">
                          <label class="w-100 fz-20 text-nowrap">{{ $t('Total to Deposit') }}</label>
                          <div class="fw-600 pr-2 text-right text-orange2">{{ getResult((amount+(amount*fee/100))/rate) }}</div>
                          <!-- <input :value="getResult((amount+(amount*fee/100))/rate)" class="form-control text-right" disabled/> -->
                        </div>
                  </div>
                  
                  </div>
                </b-col>
                  
              <b-col sm="12" md="6" class="pt-0 pb-3">
                  <div class="block-shadow-item mb-4 py-3 px-4">
                    <h4 class="pt-0 mb-3 text-center" v-if="card_id">{{chain}} {{ $t('Address') }}</h4>

                      <div v-if="to_address && card_id" class="box-border mb-4">
                        <div class="QRimage pb-4 pr-4 pl-4 pt-2">
                            <qr-code :text="to_address" color="#6D5D28"></qr-code>
                        </div>
                        <div class="d-flex mt-2 mb-2 px-4">
                            <input type="text" :value="to_address" class="form-control text-center mr-1" disabled>
                            <button @click="copyText()" class="btn btn-primary rounded">
                                <img :src="`${publicPath}/img/rcp/icon/copy.svg`"/>
                            </button>
                        </div>
                      </div>
                  

                    <div class="bg-white mb-3">
                      <div class="form-group">
                        <div class="d-flex">
                          <label class="w-100">{{ $t('TRX Hash') }}</label>
                          <div class="position-relative">
                            <img :src="`${publicPath}/img/rcp/icon/info-circle.png`" class="btn-tooltip" @click="toggleTooltip"/>
                            <div v-if="isTooltip" class="absolute tooltip-info fz-14 fw-500">
                              <div class="title">TRX Hash Code</div>
                              <div class="desc">aa10bb29bf00083026742b9eeed1e46317fbde53c5f1f058b470be0c1227d5fd</div>
                            </div>
                          </div>
                        </div>
                        <input type="text" v-model="trx_hash" name="trx_hash" value="" :placeholder="$t('TRX Hash')" class="form-control" @change="onChange('trx_hash')">
                        <div v-if="error.trx_hash" class="invalid-feedback d-block mb-3">
                          {{$t(error.trx_hash)}}
                        </div>
                      </div>
                      
                      <div class="form-group mb-3">
                        <label>{{ $t('Upload File (optional)') }}</label>

                        <div class="photo-wrapper rounded text-center">
                          <div v-if="image" class="position-relative d-inline-block">
                              <img :src="image" class="doc_image">
                              <button type="button" class="btn-remove" @click="removeImage()">x</button>
                          </div>
                          <div v-else class="d-flex align-items-center justify-content-center">
                            <div class="btn-choose-photo border-0 m-0 p-0 w-100 max-w-100">
                                <button type="button" class="btn-outline-grey-dashed bg-grey-gradient d-flex flex-column align-items-center justify-content-center w-100 fz-14 fw-400 py-5">
                                    <img :src="`${publicPath}/img/rcp/icon/upload.png`" class="w-auto">
                                    <div><a class="fw-600 fz-14" href="#">{{ $t('Click to upload') }}</a>&nbsp;<span>{{ $t('or drag and drop') }}</span></div>
                                    <div>{{ $t('PNG, JPG, or JPEG') }}</div>
                                </button>
                                <FileComponent @file-updated="captureFile($event)" :key="'uploadReceipt'"></FileComponent>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group" v-if="domain.indexOf('7dayspass.rcpaylink.com')!=-1">
                      <label :for="agree" id="agree" class="d-flex align-items-start">
                        <input v-model="agree" type="checkbox" autocomplete="off" @change="onChange('agree')" class="mt-1">
                        <span class="ml-2 w-100 text-justify">{{ $t('I acknowledge that the 7-day pass card will automatically expire after 7 days, entering suspend mode on day 8. No refund will be provided within 40 days from the deposit date.') }}</span>
                      </label>
                      <div v-if="error.agree" class="text-danger d-block">
                        {{$t(error.agree)}}
                      </div>
                    </div>

                    <div class="form-group" v-if="domain.indexOf('7dayspass.rcpaylink.com')!=-1">
                      <label :for="agree_2" id="agree_2" class="d-flex align-items-start">
                        <input v-model="agree_2" type="checkbox" autocomplete="off" @change="onChange('agree_2')" class="mt-1">
                        <span class="ml-2 w-100 text-justify">{{ $t('I understand that I need to complete the KYC process at 7dayspass.rcpaylink.com within this period to continue using.') }}</span>
                      </label>
                      <div v-if="error.agree_2" class="text-danger d-block">
                        {{$t(error.agree_2)}}
                      </div>
                    </div>

                    <div class="form-group">
                      <label :for="agree_3" id="agree_3" class="d-flex align-items-start hidden">
                        <input v-model="agree_3" type="checkbox" autocomplete="off" @change="onChange('agree_3')" class="mt-1">
                        <span class="ml-2 w-100 text-justify">{{ $t('I acknowledge all deposits will be transferred to UTGL, a registered insured and licensed public Trust Company under the Trust Ordinance. Licence no. TC007054') }}</span>
                      </label>
                      <div v-if="error.agree_3" class="text-danger d-block">
                        {{$t(error.agree_3)}}
                      </div>
                    </div>

                    <button type="button" class="btn btn-orange d-block w-100 mb-2" @click="submitDeposit">{{ $t('Submit') }}</button>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-modal id="modal-confirmation" title="CompleteMessage" @hide="$bvModal.hide('modal-confirmation')" hide-footer>
      <template #modal-title>
        {{ $t('Completed Message') }}
      </template>
      <b-col>
        <b-row cols="12" class="px-4">
          <div class="text-center w-100">
              <img :src="`${publicPath}/img/rcp/card-image.png`" class="mx-auto mb-3 d-block">
              <h1 class="fz-36 fw-600 mb-3">{{ $t('Payment Confirmation') }}</h1>
              <div class="fz-18 fw-500 mb-2">{{ $t('Please confirm the amount transferred and TRX Hash before submitting') }}</div>
              <div class="d-flex flex-column bg-peach px-3 py-2 mb-4 align-items-center fz-20 description-confirmation">
                <img :src="`${publicPath}/img/rcp/dollar-circle.png`">
                <span class="fz-36 fw-600 mb-3">USD {{ getResult((amount+(amount*fee/100))/rate) }}</span>
                <div class="d-flex w-100 text-left">
                  <div class="w-100">{{ $t('Currency Amount') }}</div>
                  <div class="fz-20 fw-600 mb-2 text-nowrap">{{ wallet_currency }} {{ getResult(amount) }}</div>
                </div>
                <div class="d-flex w-100 text-left">
                  <div class="w-100">{{ $t('TRX Hash') }}</div>
                  <div class="fz-20 fw-600 mb-2">{{ trx_hash.replace(trx_hash.substring(8,trx_hash.length-8), "....") }}</div>
                </div>
              </div>
          </div>
        </b-row>
      </b-col>
      
      <div class="d-flex align-items-center justify-content-center">
        <button class="btn btn-secondary" block @click="$bvModal.hide('modal-confirmation')">{{ $t('Cancel') }}</button>
        <button class="btn btn-orange" block @click="sendDeposit">{{ $t('Submit') }}</button>
      </div>
    </b-modal>
    <b-modal id="modal-remain" size="lg" @hide="$bvModal.hide('modal-remain')" hide-footer hide-header-close>
        <!-- <template #modal-title>
            
        </template> -->
        <b-col>
            <b-row col="12" class="px-4 ">
                <h6>{{ $t('Deposit Acknowledgment') }}</h6>
                
                <p class="fz-14 fw-400 text-justify">
                    {{ $t('ack_line_1') }}
                </p>

                <h6>{{ $t('ack_line_3') }}</h6>

                <p class="fz-14 fw-400 text-justify">
                    {{ $t('ack_line_4') }} 
                </p>

                <div class="d-flex flex-column w-100">
                  <div class="d-flex align-items-center mb-2">
                    <img :src="`${publicPath}img/fe_check.svg`"/> 
                    <span>{{ $t('ack_line_5') }}</span>
                  </div>  
                  <div class="d-flex align-items-center mb-2">
                    <img :src="`${publicPath}img/fe_check.svg`"/> 
                    <span>{{ $t('ack_line_6') }}</span>
                  </div>
                  <div class="d-flex align-items-center mb-4">
                    <img :src="`${publicPath}img/fe_check.svg`"/> 
                    <span>{{ $t('ack_line_7') }}</span>
                  </div>
                </div>

                <h6>
                    {{ $t('ack_line_8') }} 
                </h6>

                <p class="fz-14 fw-400 text-justify">
                    {{ $t('ack_line_9') }}
                </p>
                
            </b-row>
        </b-col>
  
        <div class=" mx-3">
          <button class="btn btn-orange btn-block w-100 my-3" block @click="$bvModal.hide('modal-remain')">{{ $t('Agreed and Continue') }}</button>
        </div>
    </b-modal>
    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
  import Vue from 'vue'
  import FileComponent from "@/components/FileComponent";
  import MaskAmount from "@/components/Mask/MaskAmount";
  import VueQRCodeComponent from 'vue-qrcode-component';
  import LoaderComponent from "@/components/LoaderComponent";
  import { Carousel3d, Slide } from 'vue-carousel-3d';
  import Topup from '@/services/Topup';
  import CurrencyService from '@/services/CurrencyService';
  import Global from '@/services/Global';
  import Select2 from 'v-select2-component';

  Vue.component('qr-code', VueQRCodeComponent);

  export default {
    name: 'deposit',
    data() {
      return {
        card_number:'',
        fullname:'',
        amount:0,
        fee : 0,
        code:'',
        rate:0,
        approximately:0,
        isTooltip:false,
        is_disable_card_fee:true,
        trx_hash:'',
        card_id:'',
        card_account_id:'',
        domain:'',
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        environment : process.env.VUE_APP_ENVIRONMENT,
        currency:process.env.VUE_APP_CURRENCY,
        minimum_amount:JSON.parse(process.env.VUE_APP_MINIMUM_DEPOSIT),
        wallet_currency:'USD',
        to_address : '',
        chain:'',
        deposit : new Vue(),
        card_list:[{}],
        isLoading:false,
        agree:false,
        agree_2:false,
        agree_3:true,
        image   : '',
        method  : 'Digital Assets',
        method_option: [
            {
                id: "Digital Assets",
                text: '<img src="'+(process.env.BASE_URL!='/'?process.env.BASE_URL:'')+'/img/rcp/digital-assets.svg" width="30px"><span class="px-1">Digital Assets</span>'
            },
        ],
        network : '',
        network_option: [],
        error   : {
          network:'',
          method:'',
          card_number:'',
          fullname:'',
          amount  : '',
          trx_hash : '',
          card_id : '',
          agree:'',
          agree_2:'',
          agree_3:''
        }
      }
    },
    components: {
      MaskAmount,
      FileComponent,
      LoaderComponent,
      Carousel3d,
      Slide,
      Select2
    },
    methods:{
      onSelectNetwork({id,name,address}){
        this.network = id;
        this.chain = name;
        this.to_address = address;
      },
      doEscapeMarkup(markup){
          return markup;
      },
      toggleTooltip(){
        this.isTooltip = !this.isTooltip;
      },
      getMinimum(){
        return Global.addCommas(parseFloat(this.minimum_amount[this.wallet_currency]));
      },
      getAmount(amount){
        return Global.addCommas(parseFloat(amount));
      },
      onHideModal(){

      },
      sendDeposit(){
        let params = {
          Topup:{
            card_id:this.card_id,
            card_account_id:this.card_account_id,
            card_number:this.card_number,
            domain:this.domain,
            amount_req:this.amount,
            fee:this.fee,
            amount:this.getResult((this.amount+(this.amount*this.fee/100))/this.rate),
            trx_hash:this.trx_hash,
            to_address:this.to_address
          }
        };

        if(this.image){
          params.TopupFile = [{"file":this.image}];
        }
        this.isLoading = true;
        this.$bvModal.hide('modal-confirmation');
        const self = this;
        
        Topup.request(params).then(response => {
          if(response.status == 200){
            this.isLoading = false;
            this.$swal({
              icon: 'success',
              title: self.getMessage('Successfully Submitted'),
              showConfirmButton: true,
            }).then((result) => {
              location.reload(true);
            });
          }
        }).catch(err => {
          this.isLoading = false;
          this.$bvModal.hide('modal-confirmation');
          this.checkError(err);
        });
      },
      checkCardNumber(){
        if(this.card_number){
          for (const [key, value] of Object.entries(this.error)) {
            this.error[key]="";
          }

          Topup.load({"card_number":this.card_number}).then(response => {
            if(response.status==200){
              this.card_id = response.data.data.card_id,
              this.card_account_id = response.data.data.card_account_id;
              this.domain = response.data.data.domain;
              this.fee = response.data.data.topup_fee_percent;
              this.wallet_currency = response.data.data.currency;
              this.currencyLoad(response.data.data.currency);
            }
          }).catch(err => {
              this.card_id = "";
              this.card_account_id = "";
              this.fee = "";
              this.wallet_currency = "";
              this.error.card_number = err.response.data.message;
          });
        }
      },
      currencyLoad(code){
        CurrencyService.get(code).then(response=>{
          if(response.status == 200){
            const data = response.data.response.list;
            if(data){
              this.code = data[0].code;
              this.rate = parseFloat(data[0].rate);
              this.approximately = this.getResult((this.amount+(this.amount*this.fee/100))*this.rate);
            }
          }
        });
      },
      changePrice(event){
        this.error.amount = '';
        this.amount = event;
        if(this.amount<parseFloat(this.minimum_amount[this.wallet_currency])){
          this.error.amount = "Minimum Amount is {currency} {amount}";
        }
        else if((this.amount-(this.amount*this.fee/100))<0){
          this.error.amount = "Please enter a sufficient amount";
        }

        this.approximately = this.getResult((this.amount+(this.amount*this.fee/100))*this.rate)
      },
      onChange(name){
        this.error[name]='';
      },
      copyText(){
        navigator.clipboard.writeText(this.to_address);
        this.$swal({
          icon: 'success',
          title: this.getMessage('Copy'),
          showConfirmButton: true,
        });
      },
      getMessage: function (key) {
        return this.$t(key)
      },
      getResult(amount){
        if((amount == Number.POSITIVE_INFINITY || amount == Number.NEGATIVE_INFINITY)){
          return 0;
        }
        else if(amount>0){
          return Math.ceil(amount);
        }
        else{
          return 0;
        }
      },
      submitDeposit(){

        let check = true;
        if(!this.card_number){
          check = false;
          this.error.card_number="Card number can not be blank";
        }
        if(this.agree == false && this.domain.indexOf("7dayspass.rcpaylink.com")!=-1){
          check = false;
          this.error.agree="Checkbox is required";
        }
        if(this.agree_2 == false && this.domain.indexOf("7dayspass.rcpaylink.com")!=-1){
          check = false;
          this.error.agree_2="Checkbox is required";
        }
        if(this.agree_3 == false){
          check = false;
          this.error.agree_3="Checkbox is required";
        }
        if(parseFloat(this.amount)<parseFloat(this.minimum_amount[this.wallet_currency])){
          check = false;
          this.error.amount = "Minimum Amount is {currency} {amount}";
        }
        if((this.amount-(this.amount*this.fee/100))<0){
          check = false;
          this.error.amount = "Amount should be more then 0";
        }
        if(this.trx_hash==''){
          check = false;
          this.error.trx_hash = "Trx Hash is Required";
        }
        if(this.card_id==''){
          check = false;
          this.error.card_id = "Card is Required";
        }

        if(check && this.card_number){
          this.$bvModal.show('modal-confirmation');
        }
      },
      fatchData(){
        this.network_option = [];
        Topup.chain().then(response => {
          if(response.status == 200){
            let data = response.data.wallet;

            for(let i=0;i<data.length;i++){
              data[i].icon = (data[i].icon)?data[i].icon:"https://api.oripay.us/upload/account/2025/05/06/-U45N5RWMdcoZvhRqhWB6sAOeeHSjcH6.png";
              data[i].chain = (data[i].chain)?data[i].chain:"TRC20";

              const text = '<img src="'+data[i].icon+'" width="25px"><span class="px-1">'+data[i].chain+'</span>';
              this.network_option.push({"id":data[i].id,"text":text,"address":data[i].wallet_address,"name":data[i].chain});
            }

            this.network = this.network_option[0].id;
            this.to_address = this.network_option[0].address;
            this.chain = this.network_option[0].name;
          }
        });
      },
      removeImage(){
        this.image="";
      },
      captureFile($event) {
        this.image = $event.previewBase64;
      },
      checkError(err){ 
        var self = this;
        try{
          const response = err.response;
          if(response.status == 400){
            let flag=false;
            if(response.data.data){
              Object.keys(response.data.data).forEach((key) => {
                const index = key.replace('topup-','');
                this.error[index] = response.data.data[key][0];
                flag = true;
              });
            }

            if(!flag){
              var msg = (response.data)?response.data.message:err.message;
              this.$swal({
                icon: 'info',
                html:"<b class='fz-20 mb-2'>"+self.getMessage(msg)+"</b>",
                showConfirmButton: true,
                confirmButtonText: self.getMessage('OK')
              });
            }
          }
          else{
          var msg = (response.data)?response.data.message:err.message;
            this.$notify({
            type: 'warn',
            text: msg
            })
          }
        }catch(e){
          console.log(err);
        }
      }
    },
    mounted(){
      var self = this;
      this.$nextTick(function () {
        this.$bvModal.show('modal-remain');
        self.fatchData();
      });
    }
  };
</script>

<style>
h5{
  font-size: 18px;
  font-weight: 600;
  color: #192534;
}
.disable-amount{
  border: unset !important;
  text-align: left !important;
}
input[type=checkbox] {
    width: 20px;
    height: 20px;
    background: #fff;
    border-radius: 5px;
    font-size: 16px;
}
.modal-body{
  padding: 1.5rem 0 !important;
}
.modal-content{
  overflow-x: hidden !important;
}
.btn-tooltip{
  cursor: pointer;
  width: 22px;
}
.text-nowrap{
  white-space: nowrap;
}
.tooltip-info{
  background-color: #1F2A37;
  width: 218px;
  word-break: break-all;
  padding: 10px;
  border-radius: 4px;
  position: absolute;
  top: -5px;
  -webkit-transform: translateY(-100%);
  transform: translateY(-100%);
  right: -5px;
}
.tooltip-info::after{
    content: ' ';
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #1f2a37;
    position: absolute;
    right: 7px;
    bottom: -7px;
}
.tooltip-info .title{
  color: #fff;
}
.tooltip-info .desc{
  color: #9CA3AF;
}
.description-information{
  color: #696F8C;
}
.modal-backdrop{
  background: rgba(0,0,0,.8);
}
.hidden{
  display: none !important;
}
.select2-item .form-control{
  padding-left: 0 !important;
}
.select2-item .select2-container--default .select2-selection--single .select2-selection__rendered{
  padding-left: 10px !important;
}

.select2-container--open .select2-dropdown{
  margin-top: -14px;
  border: 1px solid;
  border-radius: 10px;
  overflow: hidden;
  /* padding-top: 15px; */
  width: 211px !important;
}
.select2-container--open .select2-dropdown--below{
  margin-top: 12px;
}
.select2-container--default .select2-results__option[aria-selected=true],
.select2-container--default .select2-results__option--highlighted[aria-selected]{
  background: #f8c617 !important;
}
</style>